<template>
	<div class="view history-view">
		<HeaderBar :backFunction="onBack"/>
		<van-tabs v-model="active"
				  @change="onActiveChange"
				  swipeable
				  ref="vanSwipe">
			<van-tab title="文章">
				<div class="news-list list"
					 id="newsList"
					 v-infinite-scroll="loadMore"
					 :infinite-scroll-disabled="bottomLoading">
					<NewsItem v-for="item in newsList"
							  :key="item.id"
							  v-bind="item"
							  :beforeClick="()=>{onNewsItemClick(item.id)}" />
					<div class="no-content"
						 v-show="isNoContent && firstLoaded">———— 暂无内容 ————</div>
				</div>
			</van-tab>
			<van-tab title="智库">
				<div class="digital-list list"
					 id="digitalList"
					 v-infinite-scroll="loadMore"
					 :infinite-scroll-disabled="bottomLoading">
					<DigitalItem v-for="item in digitalList"
								 :key="item.id"
								 v-bind="item"
								 :beforeClick="()=>{onNewsItemClick(item.id)}" />
					<div class="no-content"
						 v-show="isNoContent && firstLoaded">———— 暂无内容 ————</div>
				</div>
			</van-tab>
			<van-tab title="学院">
				<div class="course-list list"
					 id="courseList"
					 v-infinite-scroll="loadMore"
					 :infinite-scroll-disabled="bottomLoading">
					<CourseItem v-for="item in courseList"
								:key="item.id"
								v-bind="item"
								:beforeClick="()=>{onNewsItemClick(item.id)}" />
					<div class="no-content"
						 v-show="isNoContent && firstLoaded">———— 暂无内容 ————</div>
				</div>
			</van-tab>
		</van-tabs>
		<PopLoading v-show="isLoading" />

	</div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import NewsItem from '../../components/NewsItem';
import DigitalItem from '../../components/DigitalItem';
import CourseItem from '../../components/CourseItem';
import HeaderBar from '../../components/HeaderBar';
import PopLoading from '../../components/PopLoading'

import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
export default {
	name: 'history',
	components: {
		'van-tabs': Tabs,
		'van-tab': Tab,
		NewsItem,
		DigitalItem,
		CourseItem,
		HeaderBar,
		PopLoading
	},
	data() {
		return {
			newsList: [],
			digitalList: [],
			courseList: [],
			page: 1,
			active: 0,
			loadFinished: false,
			bottomLoading: false,
			firstLoaded: false,
			isNoContent: false,
			isLoading: false,
			viewedItemId: 0
		};
	},
	created() {
		const { itemId, active } = this.$route.query;
		if (!!active) {
			this.active = parseInt(active);
		}
		if(!!itemId){
			this.viewedItemId = itemId;
		}
		this.init();

	},
	methods: {
		loadMore() {
			if (!this.loadFinished && this.firstLoaded) {
				this.init(this.page + 1, 30);
			}
		},
		async init(page = 1, pagesize = 30) {
			this.isLoading = true;
			const res = await apiUtil.post(apiConst.getHistory, { page, pagesize, type: this.active + 1 });
			this.isLoading = false;
			if (res.success) {
				this.page = page;
				if (this.active === 0) {
					this.newsList = this.newsList.concat(res.list)
				} else if (this.active === 1) {
					this.digitalList = this.digitalList.concat(res.list)
				} else if (this.active === 2) {
					this.courseList = this.courseList.concat(res.list)
				}
				if (res.list.length === 0) {
					this.isNoContent = true;
				}
				if (res.list.length < 30) {
					this.loadFinished = true;
				}
				if (!this.firstLoaded) {
					this.scrollToNewsItem()
				}
				this.firstLoaded = true;


			}

		},

		onBack(){
			this.$router.push('/my');
		},

		scrollToNewsItem() {
			if (this.viewedItemId) { // 下拉刷新是不需要定位到刚刚访问的newsItem的
				this.$nextTick(() => {
					let id = '';
					if (this.active === 0) {
						id = 'news_' + this.viewedItemId
					} else if (this.active === 1) {
						id = 'digital_' + this.viewedItemId
					} else if (this.active === 2) {
						id = 'course_' + this.viewedItemId
					}
					let dom = document.getElementById(id);
					if (dom) {

						this.scrollToPos(dom.offsetTop - 250)
					}
				})

			}
		},

		scrollToPos(dis) {
			this.$nextTick(() => {
				setTimeout(() => {
					let scrollTop;
					if (this.active === 0) {
						scrollTop = this.$el.querySelector('#newsList')
					} else if (this.active === 1) {
						scrollTop = this.$el.querySelector('#digitalList')
					} else if (this.active === 2) {
						scrollTop = this.$el.querySelector('#courseList')
					}
					if (scrollTop) {
						scrollTop.scrollTop = dis

					}
				}, 13)
			})
		},

		onNewsItemClick(id) {
			let query = {
				itemId: id,
				active: this.active
			}
			this.$router.push({ query })
		},

		onActiveChange(index, title) {
			this.newsList = [];
			this.digitalList = [];
			this.courseList = [];
			this.loadFinished = false;
			this.firstLoaded = false;
			this.isNoContent = false;
			this.init(1, 30, index + 1);
		}
	}
};
</script>
<style lang="stylus" scoped>
.history-view {
	overflow: hidden;

	.list {
		padding: 30px 15px;
		// max-height: 1110px;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 180px;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch

		&.digital-list {
			.digital-item-comp {
				margin: 0 15px 30px 15px;
				vertical-align: top;
			}
		}

		&.course-list {
			.course-item-comp {
				margin: 0 15px 30px 15px;
				vertical-align: top;
			}
		}

		.no-content {
			height: 90px;
			line-height: 90px;
			color: #999;
			text-align: center;
		}
	}
}
</style>
